import type { AxiosRequestConfig } from 'axios';

import { BaseClient } from '../../clients';
import { responseInterceptor } from '../../interceptors';
import { useRequestDefinition } from '../../providers';
import type { RequestConfig } from '../../types';
import { REQUEST } from '../../types';

export type SSORequestConfig = AxiosRequestConfig & RequestConfig;

export const defineSSOClient = useRequestDefinition<BaseClient, AxiosRequestConfig, SSORequestConfig>(
  ({ interceptors }) => {
    interceptors.response.use(responseInterceptor.onFulfilled, responseInterceptor.onRejected);

    return {
      id: REQUEST.SSO,
      client: BaseClient,
      options: ({ baseURL, token }) => ({
        baseURL: baseURL || '',
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token instanceof Function ? token() : token}`,
        },
      }),
    };
  },
);
